import { CATEGORY_COLORS } from './colors';

export const NODE_CATEGORIES = [
  {
    key: 'triggers',
    label: 'Triggers',
    description: 'Events that start your workflow',
    color: CATEGORY_COLORS.triggers,
    nodes: [
      { type: 'triggerNode', nodeType: 'trigger_schedule', label: 'Schedule', icon: 'Clock', description: 'Run on a time schedule' },
      { type: 'triggerNode', nodeType: 'trigger_manual', label: 'Manual Trigger', icon: 'Play', description: 'Run manually on demand' },
      { type: 'triggerNode', nodeType: 'trigger_wallettwo', label: 'WalletTwo Event', icon: 'Shield', description: 'Triggered by a WalletTwo system event' },
      { type: 'triggerNode', nodeType: 'trigger_webhook', label: 'Webhook', icon: 'Webhook', description: 'Triggered by an HTTP request' },
      { type: 'triggerNode', nodeType: 'trigger_onchain', label: 'On-Chain Event', icon: 'Activity', description: 'Triggered by blockchain event', disabled: true, hidden: true },
    ],
  },
  {
    key: 'integrations',
    label: 'Integrations',
    description: 'Connect with external services',
    color: CATEGORY_COLORS.integrations,
    nodes: [
      { type: 'actionNode', nodeType: 'action_slack', label: 'Slack', image: '/images/slackicon.png', description: 'Send a Slack message' },
      { type: 'actionNode', nodeType: 'action_telegram', label: 'Telegram', image: '/images/telegramicon.png', description: 'Send a Telegram message', disabled: true },
      { type: 'actionNode', nodeType: 'action_sendgrid', label: 'SendGrid', image: '/images/sendgridicon.png', description: 'Send an email via SendGrid' },
      { type: 'actionNode', nodeType: 'action_api_request', label: 'API Request', icon: 'Globe', description: 'Make an HTTP request to any API' },
    ],
  },
  {
    key: 'wallettwo',
    label: 'WalletTwo',
    description: 'WalletTwo platform operations',
    color: CATEGORY_COLORS.wallettwo,
    nodes: [
      { type: 'wallettwoNode', nodeType: 'wallettwo_get_member', label: 'Get Member', icon: 'UserSearch', description: 'Retrieve a single member by filter' },
      { type: 'wallettwoNode', nodeType: 'wallettwo_get_members', label: 'Get Members', icon: 'Users', description: 'Retrieve multiple members with filters' },
    ],
  },
  {
    key: 'wallet',
    label: 'Wallet',
    description: 'Blockchain wallet operations',
    color: CATEGORY_COLORS.wallet,
    nodes: [
      { type: 'walletNode', nodeType: 'wallet_load', label: 'Load Wallet', icon: 'Wallet', description: 'Import wallet via private key or mnemonic', disabled: true },
      { type: 'walletNode', nodeType: 'wallet_transfer', label: 'Transfer', icon: 'ArrowUpRight', description: 'Send tokens from a loaded wallet', disabled: true },
      { type: 'walletNode', nodeType: 'wallet_balance', label: 'Check Balance', icon: 'Coins', description: 'Query wallet token balance', disabled: true },
      { type: 'walletNode', nodeType: 'wallet_sign', label: 'Sign Message', icon: 'PenTool', description: 'Sign a message with loaded wallet', disabled: true },
    ],
  },
  {
    key: 'logic',
    label: 'Logic',
    description: 'Control flow and conditions',
    color: CATEGORY_COLORS.logic,
    nodes: [
      { type: 'conditionNode', nodeType: 'logic_foreach', label: 'For Each', icon: 'Repeat', description: 'Loop through a list of items' },
      { type: 'conditionNode', nodeType: 'logic_condition', label: 'Condition', icon: 'GitBranch', description: 'Branch based on a condition' },
      { type: 'conditionNode', nodeType: 'logic_delay', label: 'Delay', icon: 'Timer', description: 'Wait before continuing', disabled: true },
    ],
  },
];
